import styled from 'styled-components';

export const StyledContainerFullScreen = styled.div`
    height: 100vh;
    background: #f7f6ff;
    display: grid;
    align-items: center;
`;

export const StyledDraggableContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    width: 175px;
    height: 24px;
    justify-content: center;
    background: #ffffff;
    border: 1px solid #d6d6d6;
    border-radius: 3px;
`;
